import * as React from "react";
import * as ReactDOM from "react-dom";
import { action, computed } from "mobx";
import { observer, inject, Provider } from "mobx-react";
import * as DocumentReader from "../DocumentReader";
import { EPubStore } from "./EPubStore";
import { EPubNavigationView } from "./EPubNavigationView";
import { AreaUiInfoImpl } from "../States/AreaUiInfo";
import { Strings } from "../Stores/StringsStore";


export interface IEPubChapterViewProps {
	chapter: DocumentReader.Chapter;
	store?: EPubStore;
	navigation?: EPubNavigationView;
	areaUiInfo?: AreaUiInfoImpl;
	chapterOpened: () => void;
}

@inject('store')
@inject('navigation')
@inject('areaUiInfo')
@observer
export class EPubChapterView extends React.Component<IEPubChapterViewProps, {}> {

	readonly hasChildren: boolean;

	constructor(props: IEPubChapterViewProps) {
		super(props);
		this.hasChildren = this.props.chapter.subChapters !== undefined && this.props.chapter.subChapters.length > 0;
	}

	componentDidMount() {
		this.scrollToView();
	}

	componentDidUpdate() {
		this.scrollToView();
	}

	scrollToView() {
		if (this.props.chapter.isCurrent && this.props.navigation) {
			let domNode = ReactDOM.findDOMNode(this) as Element;
			let scroller = ReactDOM.findDOMNode(this.props.navigation) as Element;
			let parent = scroller.getBoundingClientRect();
			let rect = domNode.getBoundingClientRect();
			if (rect.top < parent.top) {
				scroller.scrollTop += rect.top - parent.top;
			}
			else if (rect.bottom > parent.bottom) {
				scroller.scrollTop += rect.bottom - parent.bottom;
			}
		}
	}

	@action expandTreeNode = (e: React.MouseEvent<any>) => {
		e.preventDefault();
		e.stopPropagation();
		this.props.chapter.isExpanded = !this.props.chapter.isExpanded;
	}

	@action openChapter = (e: React.MouseEvent<any>) => {
		e.preventDefault();
		e.stopPropagation();
		this.props.store.navigateTo(this.props.chapter.linkTarget);
		this.props.areaUiInfo.selectCollapse();
		this.props.chapterOpened();
	}

	@computed get buttonTooltip() {
		return this.props.chapter.isExpanded ? Strings.general.closeNode : Strings.general.expandNode;
	}

	render(): JSX.Element {
		let itemClass = this.props.chapter.isExpanded ? "treeview__node" : "treeview__node is--closed";
		let labelClass = this.props.chapter.isCurrent ? "treeview__label is--item-open" : "treeview__label";
		return <li className={itemClass}>
			<span className={labelClass} onClick={this.openChapter}>
				<a className="treeview__label-title" >{this.props.chapter.title}</a>
			</span>
			{
				this.hasChildren ? <span className="treeview__toggle" onClick={this.expandTreeNode} title={this.buttonTooltip} /> : null
			}
			{
				this.hasChildren && this.props.chapter.isExpanded ? <ul>
					{
						this.props.chapter.subChapters.map(chapter => {
							return <EPubChapterView chapter={chapter} key={chapter.linkTarget} areaUiInfo={this.props.areaUiInfo} chapterOpened={this.props.chapterOpened} />
						})
					}
				</ul> : null
			}
		</li>;
	}
}
